// import { API, API_URL } from '../settings';

let apiServer;

// apiServer = API || 'http://localhost:3000/api';

const hostname = window && window.location && window.location.hostname;

if (hostname === 'alpha.gravy.work' || hostname === 'dev.gravy.work') {
  apiServer = 'https://apidev.gravy.work/api';
} else if (hostname === 'mygravy.gravy.work' || hostname === 'access.gravy.work') {
  apiServer = 'https://api.gravy.work/api';
} else if (hostname === 'web.qa.gravywork.com') {
  apiServer = 'https://api.qa.gravywork.com/api';
} else if (hostname === 'localhost') {
  //apiServer = 'http://localhost:3000/api';
 apiServer = 'https://api.gravywork.com/api';
 // apiServer = 'https://api.qa.gravywork.com/api';

} else {
  apiServer = 'https://apidev.gravy.work/api';
}

export default apiServer;



// WEBPACK FOOTER //
// ./src/constants/server.js